
import { supabase } from '@/integrations/supabase/client';
import { EntityConfig } from '@/types/research-attachments';

/**
 * Detaches research from an entity
 */
export const detachResearch = async (
  config: EntityConfig,
  attachmentId: string
): Promise<void> => {
  const { error } = await supabase
    .from(config.tableName as any)
    .delete()
    .eq('id', attachmentId);

  if (error) {
    console.error(`Error detaching research from ${config.entityType}:`, error);
    throw error;
  }
};
